import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { formatDate } from "@/lib/media";

interface NewsCardProps {
  item: NewsItem;
  variant?: "list" | "card";
}

export default function NewsCard({ item, variant = "list" }: NewsCardProps) {
  if (variant === "card") {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group rounded-lg overflow-hidden bg-background-900 border border-background-800 hover:border-primary-500/60 transition-colors flex flex-col"
      >
        <div className="relative w-full aspect-[16/9] bg-background-800 overflow-hidden">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4 flex flex-col flex-1">
          <span className="text-xs text-primary-400 mb-2">{item.category}</span>
          <h3 className="text-sm font-medium text-foreground-100 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
            {item.title}
          </h3>
          <span className="text-xs text-foreground-500 mt-3">{formatDate(item.date)}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col sm:flex-row gap-4 rounded-lg bg-background-900 border border-background-800 p-4 hover:border-primary-500/60 transition-colors"
    >
      <div className="relative w-full sm:w-56 md:w-64 aspect-[16/9] rounded-md overflow-hidden bg-background-800 shrink-0">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-center gap-3 mb-2.5">
          <span className="px-2.5 py-0.5 rounded-md bg-primary-500/15 text-primary-400 text-xs font-medium">
            {item.category}
          </span>
          <span className="text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line"></i>
            {formatDate(item.date)}
          </span>
        </div>
        <h3 className="text-base md:text-lg font-medium text-foreground-100 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-400 mt-2.5 line-clamp-2 flex-1">{item.summary}</p>
        <span className="text-xs text-foreground-500 mt-3 flex items-center gap-1">
          <i className="ri-user-line"></i>
          {item.author}
        </span>
      </div>
    </Link>
  );
}